import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
// import { RSLevel, Returns, fetchIndicatorData, fetchRSLevelClassicData, fetchRSLevelFiboData, fetchReturnsData } from "../../../APi/Url";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { Box, LinearProgress } from "@mui/material";
import IndicatorTable from "./IndividualTables.js/IndicatorTable";
import SmaTable from "./IndividualTables.js/SmaTable";
import EmaTable from "./IndividualTables.js/EmaTable";
import RsClassicTable from "./IndividualTables.js/RsClassicTable";
import RsFiboTable from "./IndividualTables.js/RsFiboTable";
import ReturnsTable from "./IndividualTables.js/ReturnsTable";
import { TickerName } from "../../../Redux/Action";
import VolumeAnalysisTable from "./IndividualTables.js/VolumeAnalysisTable";
import MeanReversion from "./IndividualTables.js/MeanReversion";
import KeyMetrics from "./IndividualTables.js/KeyMetrics";

export default function MainTable() {
  const SelectedDropdownOption = useSelector(
    (state) => state.SelectedDropdownOption
  );
  // const isLoading = useSelector((state) => state.isLoading);
  const setActiveButton = useSelector((state) => state.ActiveButton);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const SetError = useSelector((state) => state.SetError);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Paper sx={{ width: "80%", overflow: "hidden" }}>
      <>
        {SelectedDropdownOption === "Indicator" && <IndicatorTable />}
        {SelectedDropdownOption === "SMA" && <SmaTable />}
        {SelectedDropdownOption === "EMA" && <EmaTable />}
        {SelectedDropdownOption === "RSLEVEL_CLASSIC" && <RsClassicTable />}
        {SelectedDropdownOption === "RS_LEVEL_FIBBO" && <RsFiboTable />}
        {SelectedDropdownOption === "Returns" && <ReturnsTable />}
        {SelectedDropdownOption === "Volume_Analysis" && (
          <VolumeAnalysisTable />
        )}
        {SelectedDropdownOption === "Mean_Reversion" && <MeanReversion />}
        {SelectedDropdownOption === "Key_Metrics" && <KeyMetrics />}
      </>
    </Paper>
  );
}
